import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'react-final-form'
import { Address, Error } from './styles'

const AddressLine = ({ name, validate }) => {
  return (
    <Field name={name} validate={validate}>
  {({ input, meta }) => (
      <>
        <input {...input} type="hidden" />
        {input.value?.full_address && (
          <Address>{input.value.full_address}</Address>
        )}
        {(meta.touched || meta.submitFailed) && meta.error && (
          <Error>{meta.error}</Error>
        )}
      </>
    )
  }
    </Field>
  )
}

AddressLine.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.func,
}

export default AddressLine
